import type { MenuItem } from '@/types';

/**
 * Unity docs menu
 */
export const unityDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/unity/overview' },
  { label: 'Quick Start', path: '/sdk_ref/unity/quick-start' },
  { label: 'Usage', path: '/sdk_ref/unity/usage' },
];
